import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70994bb5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "heading-main black ion-text-uppercase" }
const _hoisted_3 = { class: "ion-text-uppercase" }
const _hoisted_4 = { class: "faint-text centre" }
const _hoisted_5 = {
  key: 0,
  class: "middle"
}
const _hoisted_6 = { class: "ion-text-uppercase black title" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "faint-text" }
const _hoisted_10 = { class: "bottom" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-bold dark-txt heading" }, "Please leave a comment", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "sm-txt" }, "Star Rating", -1))
const _hoisted_13 = { class: "flex flex-column" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "review",
  class: "sm-txt label"
}, "Write a review", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderMain = _resolveComponent("HeaderMain")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_star_rating = _resolveComponent("star-rating")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_HeaderMain, {
        "page-title": "Schedule",
        "default-href": "/"
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("main", null, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.singleAgenda.name), 1),
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.fireBaseTime(_ctx.singleAgenda.start_date)) + " - " + _toDisplayString(_ctx.fireBaseTime(_ctx.singleAgenda.end_date)), 1),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.singleAgenda.roomName), 1),
              (_ctx.isFavourite)
                ? (_openBlock(), _createBlock(_component_ion_button, {
                    key: 0,
                    expand: "block",
                    fill: "outline",
                    class: "ion-margin-bottom",
                    color: "primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeFromFavourite(_ctx.singleAgenda))),
                    disabled: _ctx.isLoading
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.isLoading
                  ? 'Removing from Favourites..'
                  : 'Remove from favourites'), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : (_openBlock(), _createBlock(_component_ion_button, {
                    key: 1,
                    expand: "block",
                    color: "primary",
                    fill: "solid",
                    class: "f-normal ion-margin-top",
                    onClick: _ctx.addToFavourite,
                    disabled: _ctx.isLoading
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.isLoading ? 'Adding to Favourites..' : 'Add to favourites'), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"]))
            ]),
            (_ctx.talks && _ctx.talks.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("h2", _hoisted_6, " Speaker" + _toDisplayString(_ctx.talks.length > 1 ? 's' : ''), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.talks, (talk) => {
                    return (_openBlock(), _createElementBlock("div", {
                      onClick: () => _ctx.router.push(`/speakers/${talk.id}`),
                      class: _normalizeClass(["flex ion-align-items-center", [{ 'ion-margin-bottom': _ctx.talks.length > 1 }]]),
                      key: talk.id
                    }, [
                      _createVNode(_component_ion_thumbnail, { slot: "start" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_img, {
                            src: talk.photo,
                            class: "avatar",
                            alt: "speaker",
                            onIonError: ($event: any) => (talk.photo = _ctx.fallbackImage)
                          }, null, 8, ["src", "onIonError"])
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_8, _toDisplayString(talk.first_name) + " " + _toDisplayString(talk.last_name), 1),
                        _createElementVNode("p", null, _toDisplayString(talk.title), 1),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(talk.organisation), 1)
                      ])
                    ], 10, _hoisted_7))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _hoisted_12,
              _createVNode(_component_star_rating, {
                rating: _ctx.rating,
                "onUpdate:rating": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rating) = $event)),
                "show-rating": false,
                "round-start-rating": false,
                "star-size": 40,
                animate: ""
              }, null, 8, ["rating"]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("textarea", {
                  name: "review",
                  id: "review",
                  cols: "30",
                  rows: "8",
                  class: "review-box",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.review) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.review]
                ]),
                _createVNode(_component_ion_button, {
                  expand: "block",
                  class: "ion-margin-bottom",
                  color: "primary",
                  onClick: _ctx.handleAgendaReview,
                  disabled: _ctx.isLoadingReview || !_ctx.review
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.isLoadingReview ? 'UPDATING REVIEW..' : 'SEND COMMENT'), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}